import { useContext } from 'react';

import { VariableContext } from '../Contexts/index';

const useVariable = () => {
  const context = useContext(VariableContext);

  return context;
};

export default useVariable;
